module.exports = __webpack_public_path__ + "media/dashboard/assets/images/clock-8b32c5ce4872e696fbd9b56a17b23a7e.png";